import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkySortComponent } from './sort.component';
import { SkySortItemComponent } from './sort-item.component';
import { SkyDropdownModule } from '../dropdown';
import { SkyResourcesModule } from '../resources';


export class SkySortModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkySortComponent,
    SkySortItemComponent
  ],
  imports: [
    CommonModule,
    SkyDropdownModule,
    SkyResourcesModule
  ],
  exports: [
    SkySortComponent,
    SkySortItemComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
